var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',{attrs:{"isMine":_vm.isMine,"message":_vm.message}},[_c('video',{staticClass:"video",attrs:{"src":_vm.payload.videoUrl,"controls":""},on:{"error":_vm.videoError}})])}
var staticRenderFns = []

export { render, staticRenderFns }